(function () {
  document.documentElement.classList.remove("no-js");

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var searchInput = qs("[data-predictive-input]");
  var searchBox = qs("[data-predictive-search]");
  var searchResults = qs("[data-predictive-results]");

  if (!searchInput || !searchBox || !searchResults) return;

  function hideResults() {
    searchBox.setAttribute("hidden", "");
    searchResults.innerHTML = "";
  }

  function renderResults(payload) {
    var resources = payload && payload.resources ? payload.resources.results : null;
    if (!resources) {
      hideResults();
      return;
    }

    var products = resources.products || [];
    var collections = resources.collections || [];
    var pages = resources.pages || [];
    var articles = resources.articles || [];

    if (!products.length && !collections.length && !pages.length && !articles.length) {
      searchResults.innerHTML = '<p class="predictive-search__empty">No results found.</p>';
      searchBox.removeAttribute("hidden");
      return;
    }

    var html = ["<div class='predictive-search__group'>"];

    if (products.length) {
      html.push("<h4>Products</h4><ul class='predictive-search__list'>");
      products.forEach(function (item) {
        html.push(
          "<li><a href='" +
            item.url +
            "'><span>" +
            escapeHtml(item.title) +
            "</span><small>" +
            escapeHtml(item.price || "") +
            "</small></a></li>"
        );
      });
      html.push("</ul>");
    }

    function renderSimpleGroup(title, list) {
      if (!list.length) return;
      html.push("<h4>" + title + "</h4><ul class='predictive-search__list'>");
      list.forEach(function (item) {
        html.push("<li><a href='" + item.url + "'>" + escapeHtml(item.title) + "</a></li>");
      });
      html.push("</ul>");
    }

    renderSimpleGroup("Collections", collections);
    renderSimpleGroup("Pages", pages);
    renderSimpleGroup("Articles", articles);

    html.push("</div>");
    searchResults.innerHTML = html.join("");
    searchBox.removeAttribute("hidden");
  }

  var fetchPredictive = debounce(function (term) {
    if (!term || term.length < 2) {
      hideResults();
      return;
    }

    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(term) +
      "&resources[type]=product,collection,page,article&resources[limit]=4";

    fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data) {
          hideResults();
          return;
        }
        renderResults(data);
      })
      .catch(function () {
        hideResults();
      });
  }, 220);

  searchInput.addEventListener("input", function (e) {
    fetchPredictive(e.target.value.trim());
  });

  searchInput.addEventListener("focus", function () {
    var term = searchInput.value.trim();
    if (term.length > 1) fetchPredictive(term);
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".search-card")) {
      hideResults();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") hideResults();
  });
})();


(function() {
    // BOM character (\uFEFF) রিমুভ করার ফাংশন
    function removeBOM() {
      const walker = document.createTreeWalker(
        document.body, 
        NodeFilter.SHOW_TEXT, 
        null, 
        false
      );

      let node;
      const nodesToRemove = [];

      // সব টেক্সট নোড চেক করা হচ্ছে
      while(node = walker.nextNode()) {
        if (node.nodeValue.includes('\uFEFF')) {
          // ক্যারেক্টারটি রিমুভ করা হচ্ছে
          node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
          
          // যদি টেক্সট নোডটি একদম খালি হয়ে যায়, তবে সেটি রিমুভ করার জন্য মার্ক করা হচ্ছে
          if (node.nodeValue.trim() === "") {
            nodesToRemove.push(node);
          }
        }
      }

      // খালি টেক্সট নোডগুলো ডিলিট করা হচ্ছে
      nodesToRemove.forEach(n => n.parentNode && n.parentNode.removeChild(n));
    }

    // পেজ লোড হওয়ার সাথে সাথে রান করবে
    removeBOM();
    
    // কোনো কারণে ডাইনামিক কন্টেন্ট আসলে তার জন্যও একবার চেক করবে
    window.addEventListener('DOMContentLoaded', removeBOM);
  })();